"use client";
import dynamic from "next/dynamic";
import { useState, useEffect, useRef } from "react";
import { SpotifyData } from "@/types";
import Delayed from "@/components/Delayed";

const SpotifyProvider = dynamic(
  () => import("@/contexts/SpotifyContext").then((mod) => mod.SpotifyProvider),
  {
    ssr: false,
  }
);

// The real /api/spotify fetch lives in Content (below, mounted after the
// delay) — the widget is deferred off the initial load entirely.
const Spotify = ({ children }: { children: React.ReactNode }) => (
  <Delayed waitBeforeShow={2000}>
    <Content>{children}</Content>
  </Delayed>
);

const Content = ({ children }: { children: React.ReactNode }) => {
  const loaded = useRef(false);
  const [data, setData] = useState<SpotifyData>();

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await fetch("/api/spotify", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({ id: 4 }),
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setData(result);
        loaded.current = true;
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    }
    if ("requestIdleCallback" in window) {
      requestIdleCallback(fetchData);
    } else {
      setTimeout(fetchData, 1);
    }
  }, []);

  return (
    <>
      <div id="spotify">
        {data && <SpotifyProvider data={data}>{children}</SpotifyProvider>}
      </div>
    </>
  );
};

export default Spotify;
